import { Translator } from 'Translator';
import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import React from 'react';

const CSS = require('./TopBar.module.scss');

interface TopBarProps {
  className?: string;
  title?: any;
  onBack?: () => void;
  actions?: any;
  fixed?: boolean;
  noBorder?: boolean;
  isNarrow?: boolean;
  isInbetween?: boolean;
}

function TopBar({
  className,
  title,
  onBack,
  actions,
  fixed,
  noBorder,
  isNarrow,
  isInbetween,
}: TopBarProps) {
  const classes = classnames(CSS.TopBar, {
    [CSS.Fixed]: fixed,
    [CSS.NoBorder]: noBorder,
    [CSS.Narrow]: isNarrow,
    [CSS.Inbetween]: isInbetween,
    [className]: className,
  });
  return (
    <>
      {fixed && <div className={CSS.PushDown} />}
      <div className={classes}>
        <div className={CSS.Left}>
          {onBack && (
            <button
              className={CSS.BackButton}
              onClick={onBack}
              aria-label={Translator.translate(
                'UserEnvironment.Common.back',
                {},
                true,
              )}
            >
              <ChevronIcon
                width={8}
                height={14}
                color="#4A4A4A"
                direction="left"
                className={CSS.Icon}
              />
            </button>
          )}
        </div>
        <div className={CSS.Center}>{title}</div>
        <div className={CSS.Right}>{actions}</div>
      </div>
    </>
  );
}

export default TopBar;
